import { render } from "./SiteInfo.vue?vue&type=template&id=3af7edb8&scoped=true"
import script from "./SiteInfo.vue?vue&type=script&lang=js"
export * from "./SiteInfo.vue?vue&type=script&lang=js"

import "./SiteInfo.vue?vue&type=style&index=0&id=3af7edb8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af7edb8"]])

export default __exports__